import client from "./client";

const CategoryService = {};

CategoryService.get = function () {
  return client.get(`/category`);
};

CategoryService.switch = function (categoryId) {
  return client.put(`/category/switch/${categoryId}`);
};

CategoryService.updatePrice = function (categoryId, data) {
  return client.put(`/category/${categoryId}`, data);
};

CategoryService.getActivePrices = function () {
  return client.get(`/category/active-prices`);
};

export default CategoryService;
